/**
 * FormFieldLibraryEntry model translations
 *
 * Translation keys follow the pattern: models.form-field-library-entry.{category}.{key}
 */
export default {
    en: {
        singular: "Field library entry",
        plural: "Field library",

        fields: {
            name: "Name",
            description: "Description",
            group: "Group",
            subgroup: "Subgroup",
            field_type: "Field type",
            field_definition: "Field definition",
            icon: "Icon",
            color: "Color",
            sort_order: "Sort order",
            created_by_user_id: "Created by",
            created_at: "Created",
            updated_at: "Updated",
        },

        tabs: {
            details: "Details",
        },

        badges: {},

        actions: {
            save_to_library: "Save to library",
            duplicate: "Duplicate",
            delete: "Delete",
        },

        filters: {
            group: "Group",
            subgroup: "Subgroup",
            field_type: "Field type",
        },
    },

    fr: {
        singular: "Entree de bibliotheque de champs",
        plural: "Bibliotheque de champs",

        fields: {
            name: "Nom",
            description: "Description",
            group: "Groupe",
            subgroup: "Sous-groupe",
            field_type: "Type de champ",
            field_definition: "Definition du champ",
            icon: "Icone",
            color: "Couleur",
            sort_order: "Ordre",
            created_by_user_id: "Cree par",
            created_at: "Cree le",
            updated_at: "Modifie le",
        },

        tabs: {
            details: "Details",
        },

        badges: {},

        actions: {
            save_to_library: "Enregistrer dans la bibliotheque",
            duplicate: "Dupliquer",
            delete: "Supprimer",
        },

        filters: {
            group: "Groupe",
            subgroup: "Sous-groupe",
            field_type: "Type de champ",
        },
    },
};
